import { AssetId, Chain, Coin, Exchange, Fiat, IRatePair, RateType, Preset } from "../types"
import MinPairInfo from "../../config/abi/MinPairInfo.json";

const ratePairs: IRatePair[] = [
  {
    id: "SX:USD",
    type: RateType.DERIVED_V2,
    query: Coin.SX,
    base: Fiat.USD,
    token1AsBase: true,
    chainId: Chain.SXR,
    platformId: Exchange.SHARKSWAP,
    address: "0x32dEe3b85E7F0b5EB2E19D2124F5bc273D076Db3",
    abi: MinPairInfo,
    token0: AssetId.SX,
    token1: AssetId.USDC,
    presets: [Preset.PERSONAL, Preset.MCC, Preset.STORAGE, Preset.NEXT_GEN, Preset.SXN]
  },
  {
    id: "SHARK:SX",
    type: RateType.DERIVED_V2,
    query: Coin.SHARK,
    base: Coin.SX,
    token1AsBase: false,
    chainId: Chain.SXR,
    platformId: Exchange.SHARKSWAP,
    address: "0x6bAF120D1A2d463D124df6873fCc3B0345A19d07",
    abi: MinPairInfo,
    token0: AssetId.SX,
    token1: AssetId.SHARK,
    presets: [Preset.PERSONAL, Preset.MCC, Preset.STORAGE, Preset.NEXT_GEN, Preset.SXN]
  },
  {
    id: "SHARK:USD",
    type: RateType.DERIVED_V2,
    query: Coin.SHARK,
    base: Fiat.USD,
    token1AsBase: false,
    chainId: Chain.SXR,
    platformId: Exchange.SHARKSWAP,
    address: "0x42cB36F28f014687835F647A3b144A5df7cce6c1",
    abi: MinPairInfo,
    token0: AssetId.USDC,
    token1: AssetId.SHARK,
    presets: [Preset.PERSONAL, Preset.MCC, Preset.NEXT_GEN, Preset.SXN]
  },
  {
    id: "SX:SHARK",
    type: RateType.INDIRECT,
    query: Coin.SX,
    base: Coin.SHARK,
    path: ["SHARK:SX"],
    presets: [Preset.PERSONAL, Preset.MCC, Preset.STORAGE, Preset.NEXT_GEN, Preset.SXN]
  },
  {
    id: "ETH:SHARK",
    type: RateType.INDIRECT,
    query: Coin.ETH,
    base: Coin.SHARK,
    path: ["ETH:SX", "SX:SHARK"],
    presets: [Preset.PERSONAL, Preset.MCC, Preset.STORAGE, Preset.NEXT_GEN, Preset.SXN]
  },
  {
    id: "BTC:SHARK",
    type: RateType.INDIRECT,
    query: Coin.BTC,
    base: Coin.SHARK,
    path: ["BTC:SX", "SHARK:SX"],
    presets: [Preset.PERSONAL, Preset.MCC, Preset.STORAGE, Preset.NEXT_GEN, Preset.SXN]
  },
  {
    id: "MATIC:SHARK",
    type: RateType.INDIRECT,
    query: Coin.MATIC,
    base: Coin.SHARK,
    path: ["MATIC:SX", "SHARK:SX"],
    presets: [Preset.PERSONAL, Preset.MCC, Preset.STORAGE, Preset.NEXT_GEN, Preset.SXN]
  },
  {
    id: "SX_USDC_KLP:USD",
    type: RateType.COMPLEX,
    query: Coin.SX_USDC_KLP,
    base: Fiat.USD,
    liquidityPair: `${AssetId.SX_USDC_KLP}:${Chain.SXR}`,
    presets: [Preset.MCC, Preset.PERSONAL, Preset.NEXT_GEN, Preset.SXN]
  },
  {
    id: "SHARK_USDC_KLP:USD",
    type: RateType.COMPLEX,
    query: Coin.SHARK_USDC_KLP,
    base: Fiat.USD,
    liquidityPair: `${AssetId.SHARK_USDC_KLP}:${Chain.SXR}`,
    presets: [Preset.MCC, Preset.PERSONAL, Preset.NEXT_GEN, Preset.SXN]
  },
]

export default ratePairs

